"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const react_1 = __importDefault(require("react"));
exports.default = () => react_1.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100",
  height: "20",
  viewBox: "0 0 100 20"
}, react_1.default.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, react_1.default.createElement("path", {
  fill: "#000",
  d: "M85.345 18.494l-.107.105a4.192 4.192 0 0 1-2.965 1.213c-2.308 0-4.189-1.859-4.189-4.14V8.773h-1.661V6.607h1.661V3.39h2.48v3.218h3.721v2.167h-3.721l.003 6.897a1.7 1.7 0 0 0 1.706 1.687c.458 0 .886-.175 1.207-.494l.106-.106 1.76 1.736zM46.39 6.607l-4.638 13.206h-2.275l-2.845-9.122-2.861 9.122h-2.22l-.037-.103L26.92 6.607h2.531l.034.103 3.203 9.27 2.888-9.373h2.113l2.928 9.378 3.237-9.378zM50.503 11.956c.44-1.965 1.951-3.224 3.902-3.224 1.854 0 3.225 1.229 3.61 3.224h-7.512zm3.783-5.5c-3.71 0-6.4 2.844-6.4 6.758 0 3.921 2.797 6.768 6.648 6.768 2.232 0 4.146-.885 5.398-2.494l.088-.111-1.752-1.48-.098.122a4.513 4.513 0 0 1-3.557 1.678c-2.223 0-3.847-1.428-4.177-3.655h9.975l.028-.115c.021-.094.067-.577.067-.918 0-3.858-2.559-6.553-6.22-6.553zM63.99 19.813h2.464V0H63.99zM70.68 19.813h2.467V0H70.68zM99.94 12.56v7.262h-2.479v-7.293c-.021-1.913-1.618-3.474-3.56-3.474a3.573 3.573 0 0 0-3.1 1.793v.003l-.018.033a3.472 3.472 0 0 0-.436 1.694v7.234H87.87V0h2.477v7.884a5.502 5.502 0 0 1 2.717-1.229 4.72 4.72 0 0 1 .281-.03c.202-.018.385-.03.556-.03 3.328 0 6.04 2.674 6.04 5.965"
}), react_1.default.createElement("path", {
  fill: "#00BE96",
  d: "M19.737 3.514v2.69h-3.403V9.57h-2.722V6.205h-3.403V3.514h3.403V.15h2.722v3.364z"
}), react_1.default.createElement("path", {
  fill: "#000",
  d: "M13.612 13.605h2.722v6.055H10.21v-2.69h3.403zM6.125 16.97v2.69H0v-6.055h2.722v3.364zM6.125 3.514v2.69H2.722V9.57H0V3.514z"
})));